import React from 'react';

const TrustBoxItem = () => {
    <>
    TrustBoxItem
    </>
}

export default TrustBoxItem